import * as apiUtils from '../apiCallerProxy';
import { notificationsApiFactory } from './notificationsApiFactory';

export * from './hooks';
export default notificationsApiFactory(apiUtils);
